import { useCallback, useEffect, useState } from 'react';

import sellarModule from '../../../api/modules/seller.module';
import { RecentReviewsView } from './RecentReviews.view';

/**
 * Recent reviews, the container.
 *
 * The request is byte for byte the one this file always made:
 * `getSellerRecentReviews({ index: 0, offset: 100 })`. Nothing about the
 * payload, the params or the response handling moved.
 *
 * What is new is that a failed fetch is now VISIBLE. Before, an error was
 * `console.error`'d and the list fell through to the "No Reviews Yet" empty
 * state, so a seller with reviews and a broken endpoint was told they had no
 * reviews. Those are different facts and the screen now says which one it is.
 */
const RecentReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchReviews = useCallback(async () => {
    setLoading(true);
    setError(null);
    const res = await sellarModule.getSellerRecentReviews({
      index: 0,
      offset: 100, // Fetch more reviews at once
    });

    if (res.success) {
      setReviews(res.data.reviews || []);
    } else {
      console.error(res.error);
      setError(res.error || 'Could not load your reviews.');
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchReviews();
  }, [fetchReviews]);

  return (
    <RecentReviewsView
      reviews={reviews}
      loading={loading}
      error={error}
      onRetry={fetchReviews}
    />
  );
};

export default RecentReviews;
